"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DragAndDropOverlay;

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var USE_CLASSES = {
  app: 'drag-and-drop-overlay--app',
  component: 'drag-and-drop-overlay--component'
};

function DragAndDropOverlay(props) {
  var isOver = props.isOver,
      use = props.use;
  var modifierClass = USE_CLASSES[use];
  return _react.default.createElement("div", {
    className: (0, _classNames.default)('drag-and-drop-overlay', modifierClass, {
      'is-over': isOver
    })
  });
}

DragAndDropOverlay.propTypes = {
  isOver: _react.PropTypes.bool.isRequired,
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
};
DragAndDropOverlay.defaultProps = {
  use: 'app'
};
module.exports = exports.default;